export default /* glsl */ `vec4 opaqueColor(vec4 color) {
  return vec4(color.rgb, 1.0);
}
`;
